import React, { useEffect, useState, useRef } from 'react';
import { skills } from '../../data/skills';
interface Command {
  cmd: string;
  output: React.ReactNode;
}
export const TerminalApp: React.FC = () => {
  const [history, setHistory] = useState<Command[]>([]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const bottomRef = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    scrollToBottom();
  }, [history, input]);
  // Initial boot sequence
  useEffect(() => {
    const bootSequence = async () => {
      const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
      await delay(500);
      setHistory([{
        cmd: 'whoami',
        output: 'emmanuel_saka'
      }]);
      await delay(800);
      setHistory(prev => [...prev, {
        cmd: 'cat about.txt',
        output: 'Full Stack Developer. M5 Chip Powered. Ready to build.'
      }]);
      await delay(800);
      setHistory(prev => [...prev, {
        cmd: 'ls skills/',
        output: <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" data-id="element-189" data-mp="1j93j33k5ycjd">
              {skills.map(s => <div key={s.category} data-id="element-190" data-mp="1o6vn2vy31p3x">
                  <div className="text-blue-400 font-bold mb-1" data-id="element-191" data-mp="1o5tz5qvyx84s">
                    {s.category}/
                  </div>
                  <ul className="text-gray-300 space-y-1" data-id="element-192" data-mp="19gxve60y2h9z">
                    {s.items.map(item => <li key={item} data-id="element-193" data-mp="10i2oerq2t35m"> ├── {item}</li>)}
                  </ul>
                </div>)}
            </div>
      }]);
      setIsTyping(false);
    };
    bootSequence();
  }, []);
  const handleCommand = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const cmd = input.trim().toLowerCase();
      let output: React.ReactNode = '';
      if (cmd === 'clear') {
        setHistory([]);
        setInput('');
        return;
      } else if (cmd === 'help') {
        output = <div className="text-gray-300" data-id="element-194" data-mp="2sg5i4fbnvo62">
            Available commands:
            <br data-id="element-195" data-mp="2ogmwtifxhb2p" />
            <span className="text-green-400" data-id="element-196" data-mp="2og3dbxamqemk">whoami</span> - Display current
            user
            <br data-id="element-197" data-mp="2jibo5b1dd6m2" />
            <span className="text-green-400" data-id="element-198" data-mp="2jenso6cd6a4p">skills</span> - List technical
            skills
            <br data-id="element-199" data-mp="3g6836bh5rtv6" />
            <span className="text-green-400" data-id="element-200" data-mp="3g4oouqf2bsw1">clear</span> - Clear terminal
            output
            <br data-id="element-201" data-mp="3c3l9e50xfyvc" />
            <span className="text-green-400" data-id="element-202" data-mp="3762y47zft7k6">help</span> - Show this message
          </div>;
      } else if (cmd === 'skills') {
        output = <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" data-id="element-203" data-mp="326qfjzflmmne">
            {skills.map(s => <div key={s.category} data-id="element-204" data-mp="1vshboukypk2c">
                <div className="text-blue-400 font-bold mb-1" data-id="element-205" data-mp="1qscqir94015s">
                  {s.category}/
                </div>
                <ul className="text-gray-300 space-y-1" data-id="element-206" data-mp="1goxq0ejohspi">
                  {s.items.map(item => <li key={item} data-id="element-207" data-mp="1lmg40jcjyy4d"> ├── {item}</li>)}
                </ul>
              </div>)}
          </div>;
      } else if (cmd === 'whoami') {
        output = 'emmanuel_saka';
      } else if (cmd !== '') {
        output = <span className="text-red-400" data-id="element-208" data-mp="1vevl7eg0zio7">command not found: {cmd}</span>;
      }
      if (cmd !== '') {
        setHistory(prev => [...prev, {
          cmd: input,
          output
        }]);
      }
      setInput('');
    }
  };
  return <div className="h-full w-full bg-[#1c1c1e] text-gray-200 font-mono p-4 overflow-y-auto mac-scrollbar text-sm" onClick={() => document.getElementById('terminal-input')?.focus()} data-id="element-209" data-mp="29dlfkmbgn48v">
      <div className="text-gray-400 mb-4" data-id="element-210" data-mp="f0n8scoyypqa">
        Last login: {new Date().toString().split(' ').slice(0, 4).join(' ')} on
        ttys000
        <br data-id="element-211" data-mp="2aer1cp1vlgzm" />
        Type 'help' to see available commands.
      </div>

      {history.map((item, i) => <div key={i} className="mb-4" data-id="element-212" data-mp="25gfriebkz6he" data-mpi={i}>
          <div className="flex items-center gap-2" data-id="element-213" data-mp="25fecxzvcw1ux">
            <span className="text-green-400" data-id="element-214" data-mp="2jffi3rinlvg7">emmanuel@macbook-pro</span>
            <span className="text-blue-400" data-id="element-215" data-mp="2jdbdt8gueufe">~</span>
            <span className="text-gray-400" data-id="element-216" data-mp="2ehnpswe3k7bh">$</span>
            <span data-id="element-217" data-mp="2eermesjhcqfn">{item.cmd}</span>
          </div>
          <div className="mt-1" data-id="element-218" data-mp="1qs1mbwqoz5xo">{item.output}</div>
        </div>)}

      {!isTyping && <div className="flex items-center gap-2" data-id="element-219" data-mp="1mqg4ry37q3h5">
          <span className="text-green-400" data-id="element-220" data-mp="1mnlngffhwyry">emmanuel@macbook-pro</span>
          <span className="text-blue-400" data-id="element-221" data-mp="20i4g3z5n0nx2">~</span>
          <span className="text-gray-400" data-id="element-222" data-mp="1vpl3b4erxwtb">$</span>
          <input id="terminal-input" type="text" value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleCommand} className="flex-1 bg-transparent outline-none border-none text-gray-200" autoFocus autoComplete="off" spellCheck="false" data-id="element-223" data-mp="1vos3yoi5a9l7" />
        </div>}
      <div ref={bottomRef} data-id="element-224" data-mp="3jh2cgjredlmx" />
    </div>;
};